import { getCookie, updateCookie } from './browserCookieWrapper';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export var OPT_IN_COOKIE_NAME = 'OptInPrg';
export function isClientOptingReact() {
    return isClientOpting(2 /* React */);
}
export function isClientOptingJsmvvm() {
    return isClientOpting(1 /* Jsmvvm */);
}
function isClientOpting(client) {
    var optinCookieValue = getCookie(OPT_IN_COOKIE_NAME);
    return optinCookieValue == '' + client;
}
export function optIntoJsmvvmClient() {
    updateClientOptInStateCookie(1 /* Jsmvvm */);
}
export function optIntoJsmvvmClientAndRedirect(modulePath) {
    optIntoJsmvvmClient();
    var sessionType = getUserConfiguration().SessionSettings.WebSessionType;
    var redirectPath = '/owa/';
    var params = [];
    if (sessionType) {
        params.push('isc=' + sessionType);
    }
    if (modulePath) {
        params.push(modulePath);
    }
    if (params.length > 0) {
        redirectPath = redirectPath + '?' + params.join('&');
    }
    location.assign(redirectPath);
}
export function updateClientOptInStateCookie(value) {
    if (value == null) {
        updateCookie(OPT_IN_COOKIE_NAME);
    }
    else {
        updateCookie(OPT_IN_COOKIE_NAME, '' + value, { path: '/' });
    }
}
//# sourceMappingURL=mailOptinUtility.js.map